import React from "react";
import styles from "../../../Styles/Modules/Select.module.scss";
import { useTranslation } from "react-i18next";
import { Settings } from "../../../settings";
import { playSound } from "../../../State/Slices/soundsSlice";
import { useDispatch } from "react-redux";
import { SOUND_NAME } from "../../../sounds";

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.select}>
      <label className={styles.selectLabel}>
        {t("language")}
        <select
          className={styles.selectInput}
          value={i18n.language}
          onChange={(e) => {
            dispatch(playSound(SOUND_NAME.click));
            i18n.changeLanguage(e.target.value);
          }}
        >
          {Settings.LANGUAGES.map((language) => (
            <option key={language.value} value={language.value}>
              {t(language.label)}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default LanguageSelector;
